import { FC, ReactNode } from 'react';

import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';
import { useSelectedCoworkingTypeSelector } from 'shared/hooks/selectors/coworking/useSelectedCoworkingTypeSelector';

import { StickyBlock } from '../UI/StickyBlock';

import { InfoCardBody } from './InfoCardBody';
import { InfoCardHeader } from './InfoCardHeader';
import { NoneSelectedOfferHeader } from './NoneSelectedOfferHeader';
import { FixedWorkplaceHeaderContainer, FlexibleWorkplaceHeaderContainer } from './WorkplaceInCoworkingHeader';

import * as styles from './StickyCoworkingCard.css';

export const StickyCoworkingCard: FC = () => {
  const selectedCoworkingType = useSelectedCoworkingTypeSelector();

  const infoCardHeaderView = ((): ReactNode => {
    switch (selectedCoworkingType) {
      case SelectedCoworkingType.FixedWorkplace:
        return <FixedWorkplaceHeaderContainer />;

      case SelectedCoworkingType.FlexibleWorkplace:
        return <FlexibleWorkplaceHeaderContainer />;

      case SelectedCoworkingType.SeparateOffice:
        return <InfoCardHeader />;

      case SelectedCoworkingType.None:
        return <NoneSelectedOfferHeader />;

      default:
        return null;
    }
  })();

  return (
    <StickyBlock containerClassName={styles['container']}>
      {infoCardHeaderView}
      <InfoCardBody />
    </StickyBlock>
  );
};

StickyCoworkingCard.displayName = 'StickyCoworkingCard';
